import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import validate from "validate.js";
import { ProgramDropdown } from "CommonDropdowns";
import { setupProgramForTracking, hideProgramValidationError } from "actions";

const schema = {
  program_id: {
    presence: { allowEmpty: false, message: "^Program is required" },
  },
};

const AddToTrackingModal = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const validation_error = useSelector(
    (state) => state.timesheetProgramState?.validation_error
  );
  const session = useSelector((s) => s.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const initialFormState = {
    isValid: false,
    values: {
      object_viewed_id: object_viewed_id,
    },
    touched: {},
    errors: {},
  };

  const [formState, setFormState] = useState(initialFormState);
  const [programValue, setProgramValue] = useState(null);

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  useEffect(() => {
    if (validation_error) {
      setFormState((formState) => ({
        ...formState,
        isValid: false,
        errors: validation_error || {},
      }));
    }
  }, [validation_error]);

  const resetForm = () => {
    setFormState(initialFormState);
    setProgramValue(null);
  };

  const onClose = () => {
    resetForm();
    handleClose();
  };

  const handleProgramChange = (selectedOption) => {
    setProgramValue(selectedOption);
    const programId = selectedOption ? selectedOption.value : null;

    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        program_id: programId,
      },
      touched: {
        ...formState.touched,
        program_id: true,
      },
    }));
    dispatch(hideProgramValidationError("program_id"));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (formState.isValid) {
      let data = formState.values;
      dispatch(setupProgramForTracking(data, onClose));
    }
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <Modal show={show} onHide={onClose} centered style={{ '--bs-modal-width': '420px' }}>
      <div className="p-2">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="font-20 font-weight-bold heading-color">
              Select a Program
            </h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <ProgramDropdown
              isMulti={false}
              programValue={programValue}
              setProgramValue={setProgramValue}
              programOnChange={handleProgramChange}
              error={hasError("program_id") && formState.errors.program_id[0]}
              trackingProgram={0}
            />
            <Row className="mt-3">
              <Col lg={6}>
                <button
                  type="button"
                  className="c-b-btn w-100"
                  onClick={onClose}
                >
                  Cancel
                </button>
              </Col>
              <Col lg={6}>
                <button
                  type="submit"
                  className="n-u-btn w-100"
                  disabled={!formState.isValid}
                >
                  Setup For Tracking
                </button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default AddToTrackingModal;
